import React, { useEffect, useState } from "react";

import { BranchFeaturesDto } from "services/organizationBranches/restModels";
import { Button } from "shared/ui/Button";
import { ToggleSwitch } from "shared/ui/ToggleSwitch";

import { Actions, Form } from "../../styles";

interface FeaturesTabProps {
    features: BranchFeaturesDto;
    saving: boolean;
    onSave: (isOldPriceLabelEnabled: boolean) => void;
}

export const FeaturesTab = ({ features, saving, onSave }: FeaturesTabProps) => {
    const [isOldPriceLabelEnabled, setIsOldPriceLabelEnabled] = useState(
        features.isOldPriceLabelEnabled
    );

    useEffect(() => {
        setIsOldPriceLabelEnabled(features.isOldPriceLabelEnabled);
    }, [features]);

    return (
        <Form>
            <ToggleSwitch
                checked={isOldPriceLabelEnabled}
                onChange={setIsOldPriceLabelEnabled}
                label="Показывать старую цену"
                hint="Перечёркнутая цена рядом с текущей в меню гостя"
                disabled={saving}
            />

            <Actions>
                <Button
                    onClick={() => onSave(isOldPriceLabelEnabled)}
                    disabled={saving || isOldPriceLabelEnabled === features.isOldPriceLabelEnabled}
                >
                    Сохранить
                </Button>
            </Actions>
        </Form>
    );
};
